import React from 'react';
import { shape, string } from 'prop-types';
import cx from 'classnames';
import Tooltip from 'components/Map/MapComponents/Tooltip';
import TooltipItem from 'components/Map/MapComponents/TooltipItem';
import SegmentIcon from 'icons/segment.inline.svg';
import SegmentBrokenIcon from 'icons/segment-broken.inline.svg';
import segmentStatus from 'propTypes/segmentStatus';

import styles from './segment-tooltip.scss';

// @TODO use new components: WithTrend, SpeedDisplay, TimeDisplay, SegmentNameDisplay
export default function SegmentTooltip({ status, name }) {
  const isReporting = status !== 'disconnected';

  return (
    <Tooltip sticky offset={[5, -10]} className={cx(styles.main, styles[`status-${status}`])}>
      <TooltipItem label="segment">
        <div className={styles.segment}>
          {isReporting
            ? <SegmentIcon className={styles.segmentIcon} />
            : <SegmentBrokenIcon className={styles.segmentIcon} />}
          <div className={styles.segmentName}>
            <div>
              {name.from}
            </div>
            <div>
              {name.to}
            </div>
          </div>
        </div>
      </TooltipItem>
    </Tooltip>
  );
}

SegmentTooltip.propTypes = {
  status: segmentStatus.isRequired,
  name: shape({ to: string.isRequired, from: string.isRequired }).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/CreateRoute/SegmentTooltip/index.js